import type { JSX } from 'solid-js';

export function IssueCardSkeleton(): JSX.Element {
  return (
    <div
      class="cursor-default"
      role="status"
      aria-label="Loading issue card"
      style="height: 169px; overflow: hidden; border: 1px solid #e5e7eb;"
    >
      <div
        class="w-full h-full bg-white animate-pulse flex flex-col"
        style="overflow: hidden;"
      >
        {/* Content area */}
        <div class="flex-1 px-2 pt-2 overflow-hidden">
          <div class="flex gap-2 items-start">
            {/* Thumbnail skeleton */}
            <div
              class="flex-shrink-0 w-[40px] h-[40px] bg-gray-200 dark:bg-gray-700"
              // eslint-disable-next-line @typescript-eslint/naming-convention -- SolidJS CSSProperties requires kebab-case
              style={{ 'border-radius': '2px' }}
            />

            <div class="flex-1 min-w-0">
              {/* Header: ID + Status skeleton */}
              <div class="flex items-center justify-between gap-1">
                <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-16" />
                <div
                  class="bg-gray-200 dark:bg-gray-700"
                  style={{
                    width: '3rem',
                    height: '1.25rem',
                    // eslint-disable-next-line @typescript-eslint/naming-convention -- SolidJS CSSProperties requires kebab-case
                    'border-radius': '1rem',
                  }}
                />
              </div>

              {/* Title skeleton */}
              <div class="mt-1">
                <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-full max-w-[200px] mb-1" />
                <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-3/4 max-w-[150px]" />
              </div>
            </div>
          </div>

          {/* Badges row skeleton (Type, Priority) */}
          <div class="flex items-center justify-between mt-1">
            <div class="flex items-center gap-2 py-1">
              <div class="w-4 h-4 bg-gray-200 rounded-full dark:bg-gray-700" />
              <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-12" />
            </div>
            <div class="flex items-center gap-2 py-1">
              <div class="w-4 h-4 bg-gray-200 rounded-full dark:bg-gray-700" />
              <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-14" />
            </div>
          </div>
        </div>

        {/* Footer skeleton */}
        <div
          class="flex items-center justify-between px-2 py-2 bg-gray-100"
          style="border-top: 1px solid #e5e7eb;"
        >
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <div class="w-4 h-4 bg-gray-300 rounded-full dark:bg-gray-600 flex-shrink-0" />
            <div class="h-2 bg-gray-300 rounded-full dark:bg-gray-600 w-20" />
          </div>
          <div class="flex items-center gap-2 w-26 flex-shrink-0">
            <div class="w-4 h-4 bg-gray-300 rounded-full dark:bg-gray-600" />
            <div class="h-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24" />
          </div>
        </div>
      </div>
      <span class="sr-only">Loading issue card...</span>
    </div>
  );
}
